import PageNotFound from '@/views/PageNotFound'
import BpmOsgpoModule from '@/helpers/Modules/Product/BpmOsgpoModule'

export function useBpmInit ({
  policy,
  mode,
  route,
  router,
  store,
  user,
  duration,
  treatyMinDate,
  treatyStartDate,
  treatyMinEndDate,
  treatyMaxEndDate,
}) {
  // --- Access control ---
  function redirectIfNoApc () {
    if (user.value?.role === 8 && !user.value?.apc) {
      router.push({ path: 'not-found', component: PageNotFound })
    }
  }

  function redirectIfUserNotAllowed () {
    if (!BpmOsgpoModule.Validator.isUserAllowed(user.value)) {
      router.push({ path: 'not-found', component: PageNotFound })
    }
  }

  // --- Layout ---
  function syncLayoutPageTitle () {
    if (mode.value.code === 'rewrite') {
      const base = route.meta.title
      store.commit('setLayoutPageTitle', `${base} (${mode.value.title})`)
    } else {
      store.commit('setLayoutPageTitle', null)
    }
  }

  // --- Policy bootstrap ---
  function setPolicyApc () {
    policy.apc = user.value?.apc ?? null
  }

  function replacePolicy (newPolicy) {
    store.commit('replaceBpmPolicy', newPolicy)
  }

  // --- Treaty dates ---
  function syncTreatyTerm () {
    if (!duration.value || !policy?.treaty?.date) {
      return
    }
    const endDate = BpmOsgpoModule.Treaty.calculateEndDate(policy.treaty.date, duration.value)
    if (endDate) {
      policy.treaty.term = endDate
    }
  }

  function clampTreatyEndDate () {
    if (!BpmOsgpoModule.Treaty.isEndDate(policy?.treaty?.term)) {
      return false
    }
    const minEnd = treatyMinEndDate.value
    if (minEnd && policy.treaty.term < minEnd) {
      policy.treaty.term = minEnd
      duration.value = null
      return true
    }
    const maxEnd = treatyMaxEndDate.value
    if (maxEnd && policy.treaty.term > maxEnd) {
      policy.treaty.term = maxEnd
      duration.value = null
      return true
    }
    return false
  }

  function applyModeTreatySettings () {
    if (!policy?.treaty) {
      return
    }
    if (!policy.treaty.date || policy.treaty.date < treatyMinDate.value) {
      policy.treaty.date = treatyStartDate.value
    }
    const allowedDurations = BpmOsgpoModule.Treaty.durationsDictionary(mode.value)
    const isDurationAllowed = (dur) => dur && allowedDurations.some(item => {
      return item.id.type === dur.type && item.id.value === dur.value
    })
    if (!BpmOsgpoModule.Treaty.isEndDate(policy.treaty.term)) {
      duration.value = isDurationAllowed(duration.value)
        ? duration.value
        : BpmOsgpoModule.Treaty.DEFAULT_DURATION
      syncTreatyTerm()
    } else {
      if (clampTreatyEndDate()) {
        return
      }
      if (duration.value && !isDurationAllowed(duration.value)) {
        duration.value = BpmOsgpoModule.Treaty.DEFAULT_DURATION
        syncTreatyTerm()
      }
    }
  }

  function resetWizard () {
    store.dispatch('bpmResetWizard', { treatyDate: treatyStartDate.value })
    applyModeTreatySettings()
  }

  return {
    syncLayoutPageTitle,
    redirectIfNoApc,
    redirectIfUserNotAllowed,
    setPolicyApc,
    syncTreatyTerm,
    clampTreatyEndDate,
    applyModeTreatySettings,
    replacePolicy,
    resetWizard,
  }
}
